import React, { useState } from 'react';
import './style.scss';
import { makeStyles } from '@material-ui/core';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getInsuranceLocalInfo } from '../../utils';
import { setSelectedInsurance } from '../../redux/InsuranceTypes';
import { activeInsurances } from '../../config';

const useStyles = makeStyles({
  imageContainer: {
    cursor: 'pointer',
  },
});

export default function Banner({
  insuranceId,
  insuranceName,
  insuranceCompany,
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const classes = useStyles();
  const [hover, setHover] = useState(false);

  const { user } = useSelector(({ user }) => ({
    user,
  }));

  const insuranceInfo = getInsuranceLocalInfo(insuranceName);
  const active = activeInsurances.includes(insuranceName);

  const hasSubProducts = insuranceCompany.products.length > 1;

  const handleOnclick = () => {
    if (!active) return;
    if (user.empleado && insuranceName === 'ROBO EN CAJERO AUTOMATICO') return;
    dispatch(
      setSelectedInsurance({
        insuranceId,
        insuranceName,
        insuranceCompany,
        insuranceProductId:
          !hasSubProducts && insuranceCompany.products[0].productId,
        ...insuranceInfo,
      })
    );

    if (insuranceName === 'INTEGRAL DE COMERCIO') {
      history.push(`${insuranceInfo.url}/actividad`);
    } else if (insuranceName === 'AUTOMOTOR') {
      history.push(`${insuranceInfo.url}/cotizacion`);
    } else {
      const url = hasSubProducts
        ? `${insuranceInfo.url}/opciones`
        : `${insuranceInfo.url}/planes`;
      history.push(url);
    }
  };

  return (
    <div className='bannerCarHome'>
      <div
        onMouseEnter={() => active && setHover(true)}
        onMouseLeave={() => active && setHover(false)}
        onClick={handleOnclick}
        className={classes.imageContainer}
      >
        <img
          src={require('../../img/bannerCarPromo.jpg')}
          alt='Seguro de Autos'
          title='Seguro de Autos'
        />
      </div>
    </div>
  );
}
